(function() {
  let chatInitialized = false;
  let scrollListenerActive = false;
  let scrollHandler = null;

  function loadHubSpotWidget() {
    console.log('Loading HubSpot chat widget');

    function loadWidget() {
      if (window.HubSpotConversations) {
        const status = window.HubSpotConversations.widget.status();
        if (!status.loaded) {
          window.HubSpotConversations.widget.load();
          chatInitialized = true;
        }
      } else {
        window.hsConversationsOnReady = [
          function() {
            window.HubSpotConversations.widget.load();
            chatInitialized = true;
          }
        ];
      }
    }

    loadWidget();
  }

  function hideHubSpotChat() {
    console.log('Hiding HubSpot chat for DTC mode');

    // Remove scroll listener if active
    if (scrollListenerActive && scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollListenerActive = false;
    }

    // Remove widget if loaded
    if (window.HubSpotConversations && chatInitialized) {
      const status = window.HubSpotConversations.widget.status();
      if (status.loaded) {
        window.HubSpotConversations.widget.remove();
      }
    }
  }

  function setupScrollListener() {
    // Don't set up if already active
    if (scrollListenerActive) return;

    console.log('Setting up HubSpot chat scroll listener for B2B mode');

    scrollHandler = function() {
      if (!scrollListenerActive) return; // Guard against race conditions

      loadHubSpotWidget();
      window.removeEventListener('scroll', scrollHandler);
      scrollListenerActive = false;
    };

    window.addEventListener('scroll', scrollHandler, { once: true });
    scrollListenerActive = true;
  }

  function checkAndUpdateChat() {
    const userExperience = document.body.getAttribute('data-user-experience');

    if (userExperience === 'b2b') {
      setupScrollListener();
    } else if (userExperience === 'dtc') {
      hideHubSpotChat();
    }
  }

  // Check initial state on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndUpdateChat);
  } else {
    checkAndUpdateChat();
  }

  // Listen for toggle button clicks
  document.addEventListener('click', function(event) {
    const toggleElement = event.target.closest('.toggle-header-title-bar-container__toggle-dtc-element');
    if (toggleElement) {
      // Wait a bit for the attribute to update
      setTimeout(checkAndUpdateChat, 100);
    }
  });

  // Watch for body attribute changes (fallback)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-user-experience') {
          checkAndUpdateChat();
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-user-experience']
    });
  }
})();
